import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./i18n/i18n";
import Spinner from "./Spinner";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Suspense fallback={<Spinner />}>
      <App />
    </Suspense>
  </React.StrictMode>
);
